const FALLBACK_TIME_ZONES = [
  "UTC",
  "Europe/London",
  "Europe/Dublin",
  "Europe/Paris",
  "Europe/Berlin",
  "Europe/Madrid",
  "Europe/Amsterdam",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Toronto",
  "America/Vancouver",
  "Asia/Dubai",
  "Asia/Kolkata",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Australia/Sydney",
  "Pacific/Auckland",
] as const;

export function detectedScheduleTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
}

export function scheduleTimeZoneOptions(
  currentTimeZone?: string,
): readonly string[] {
  const supportedValuesOf = (
    Intl as typeof Intl & {
      supportedValuesOf?: (key: "timeZone") => string[];
    }
  ).supportedValuesOf;
  const supported = supportedValuesOf
    ? supportedValuesOf("timeZone")
    : [...FALLBACK_TIME_ZONES];

  return [
    ...new Set([detectedScheduleTimeZone(), currentTimeZone, ...supported]),
  ]
    .filter((value): value is string => Boolean(value))
    .sort((left, right) => left.localeCompare(right));
}

export function scheduleTimeZoneLabel(timeZone: string): string {
  return timeZone.replaceAll("_", " ");
}
